import { Pipe, PipeTransform } from '@angular/core';
import { sprintf } from 'sprintf-js';

const activityText = require('./activity-text.json');

@Pipe({
  name: 'activityText',
})
export class ActivityTextPipe implements PipeTransform {
  transform(value: string): string {
    const [key, params] = value.split(':');

    if (key in activityText) {
      const text = activityText[key];

      if (typeof params === 'undefined') {
        return text;
      }

      return sprintf(text, ...params.split(','));
    }

    return value;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/activity-text.pipe.ts